/* Domma · mecanismo de digestión animado (canvas sobre SVG, coordenadas del viewBox 400×400).
   Fases (10 s): 0 entra la comida · 1 las enzimas la cortan · 2 los nutrientes pasan al intestino. */
(function () {
  var T = [0, 3.4, 7, 10.4];                 // inicio de cada fase y fin de ciclo (s)
  var NAMES = ['Entra la comida', 'Las enzimas la cortan', 'Tu cuerpo la aprovecha'];
  var LUMEN = { x: 228, y: 238, rx: 92, ry: 78 };
  var EXIT = [[150, 296], [112, 306], [76, 314], [50, 326], [34, 352]];
  var FOOD = [ // destino, tamaño, color (carne, pan, frijol, queso, tortilla)
    { x: 205, y: 262, w: 60, h: 40, c: '#b9623d', r: 12 }, { x: 272, y: 228, w: 54, h: 34, c: '#e2b366', r: 15 },
    { x: 240, y: 300, w: 30, h: 22, c: '#5b2e25', r: 10 }, { x: 296, y: 282, w: 38, h: 38, c: '#f3cf6f', r: 7 },
    { x: 178, y: 214, w: 48, h: 26, c: '#e9c98f', r: 12 }];
  var rnd = function (a, b) { return a + Math.random() * (b - a); };
  var ease = function (t) { return t < 0 ? 0 : t > 1 ? 1 : 1 - Math.pow(1 - t, 3); };

  function Mech(root, still) {
    this.still = !!still; this.root = root; this.cv = root.querySelector('.dm-mech__cv'); this.ctx = this.cv.getContext('2d');
    this.btns = root.querySelectorAll('[data-step]'); this.phN = root.querySelector('[data-ph-n]'); this.phT = root.querySelector('[data-ph-t]');
    this.t = 0; this.last = 0; this.run = false; this.phase = -1;
    var self = this;
    this.btns.forEach(function (b) { b.addEventListener('click', function () { self.jump(+b.dataset.step); if (self.still) self.drawStill(+b.dataset.step); }); });
    this.resize(); window.addEventListener('resize', function () { self.resize(); if (self.still) self.drawStill(self.phase); });
    this.reset();
    if (this.still) { this.drawStill(1); return; }
    var io = new IntersectionObserver(function (e) { self.run = e[0].isIntersecting; if (self.run) { self.last = performance.now(); requestAnimationFrame(self.loop.bind(self)); } }, { threshold: 0.15 });
    io.observe(root);
  }
  Mech.prototype.resize = function () {
    var r = this.cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    this.cv.width = r.width * d; this.cv.height = r.height * d; this.k = (r.width / 400) * d;
  };
  Mech.prototype.reset = function () {
    this.food = FOOD.map(function (f, i) { return { tx: f.x, ty: f.y, x: 185, y: -20 - i * 30, w: f.w, h: f.h, c: f.c, r: f.r, s: 1, rot: rnd(-.4, .4), d: i * .35 }; });
    this.enz = []; this.parts = [];
    for (var i = 0; i < 16; i++) this.enz.push({ x: 185 + rnd(-8, 8), y: rnd(-140, -10), a: rnd(0, 6.28), tgt: i % FOOD.length, o: 0, sp: rnd(.8, 1.3) });
  };
  Mech.prototype.jump = function (p) { this.reset(); this.t = T[p]; if (p >= 1) this.fastForward(p); this.setPhase(p, true); };
  Mech.prototype.fastForward = function (p) {
    var self = this;
    this.food.forEach(function (f) { f.x = f.tx; f.y = f.ty; });
    if (p === 2) { this.food.forEach(function (f) { f.s = .15; for (var i = 0; i < 10; i++) self.emit(f); }); }
  };
  Mech.prototype.setPhase = function (p, force) {
    if (p === this.phase && !force) return; this.phase = p;
    this.btns.forEach(function (b) { b.classList.toggle('is-on', +b.dataset.step === p); });
    if (this.phN) { this.phN.textContent = p + 1; this.phT.textContent = NAMES[p]; }
  };
  Mech.prototype.drawStill = function (p) {
    this.jump(p);
    var self = this;
    if (p === 1) { this.food.forEach(function (f) { f.s = .55; for (var i = 0; i < 5; i++) self.emit(f); });
      this.enz.forEach(function (e, i) { var f = self.food[e.tgt]; e.o = 1; e.a = i * 1.7; var R = 18 + f.w * .35; e.x = f.x + Math.cos(e.a) * R; e.y = f.y + Math.sin(e.a) * R * .8; }); }
    if (p === 2) { this.parts.forEach(function (q, i) { var w = EXIT[i % 3]; q.x = w[0] + (Math.random() - .5) * 16; q.y = w[1] + (Math.random() - .5) * 10; }); }
    this.draw(p);
  };
  Mech.prototype.emit = function (f) {
    var nutri = Math.random() < .55;
    this.parts.push({ x: f.x + rnd(-f.w / 3, f.w / 3), y: f.y + rnd(-f.h / 3, f.h / 3), vx: rnd(-.6, .6), vy: rnd(-.6, .6),
      r: rnd(1.6, 3.6), c: nutri ? '#f2a33a' : f.c, wp: 0, o: 1, j: rnd(0, 6.28) });
  };
  Mech.prototype.loop = function (now) {
    if (!this.run) return;
    var dt = Math.min(.05, (now - this.last) / 1000); this.last = now; this.t += dt;
    if (this.t >= T[3]) { this.t = 0; this.reset(); }
    var p = this.t < T[1] ? 0 : this.t < T[2] ? 1 : 2; this.setPhase(p);
    var prog = (this.t - T[p]) / (T[p + 1] - T[p]);
    this.btns.forEach(function (b) { var u = b.querySelector('u'); if (u) u.style.width = (+b.dataset.step === p ? prog * 100 : 0) + '%'; });
    this.update(dt, p); this.draw(p);
    requestAnimationFrame(this.loop.bind(this));
  };
  Mech.prototype.update = function (dt, p) {
    var t = this.t, self = this;
    // comida: cae por el esófago y se asienta
    this.food.forEach(function (f) {
      var k = ease((t - f.d) / 1.6);
      if (t < T[1] + .2) { f.x = 185 + (f.tx - 185) * k; f.y = -20 + (f.ty + 20) * k; }
      if (p === 1) { var before = f.s; f.s = Math.max(.12, f.s - dt * .26); if (Math.random() < 6 * dt * (before > .13 ? 1 : 0)) self.emit(f); }
      if (p === 2) { f.s = Math.max(0, f.s - dt * .25); if (f.s > .02 && Math.random() < 3 * dt) self.emit(f); }
    });
    // enzimas: entran en la fase 1 y orbitan su trozo
    this.enz.forEach(function (e, i) {
      if (p === 0) { e.o = 0; return; }
      var f = self.food[e.tgt];
      if (p === 1) {
        e.o = Math.min(1, e.o + dt * 2); e.a += dt * 2.4 * e.sp;
        var R = 18 + f.w * f.s * .6, tx = f.x + Math.cos(e.a) * R, ty = f.y + Math.sin(e.a) * R * .8;
        e.x += (tx - e.x) * Math.min(1, dt * 3.2); e.y += (ty - e.y) * Math.min(1, dt * 3.2);
      } else { e.o = Math.max(0, e.o - dt * .9); e.a += dt * 2; e.x += Math.cos(e.a) * .3; e.y += Math.sin(e.a) * .3; }
    });
    // partículas: se mueven dentro del estómago y en la fase 2 salen por el píloro
    this.parts.forEach(function (q) {
      q.j += dt * 3;
      if (p < 2) {
        q.vx += Math.cos(q.j) * .02; q.vy += Math.sin(q.j * 1.3) * .02; q.vx *= .96; q.vy *= .96;
        q.x += q.vx; q.y += q.vy;
        var dx = (q.x - LUMEN.x) / LUMEN.rx, dy = (q.y - LUMEN.y) / LUMEN.ry;
        if (dx * dx + dy * dy > 1) { q.x -= q.vx * 2; q.y -= q.vy * 2; q.vx *= -.5; q.vy *= -.5; }
      } else {
        var w = EXIT[Math.min(q.wp, EXIT.length - 1)], ddx = w[0] - q.x, ddy = w[1] - q.y, dd = Math.hypot(ddx, ddy) || 1;
        var sp = 55 + q.r * 8;
        q.x += ddx / dd * sp * dt + Math.cos(q.j) * .25; q.y += ddy / dd * sp * dt + Math.sin(q.j) * .25;
        if (dd < 8 && q.wp < EXIT.length) q.wp++;
        if (q.wp >= EXIT.length - 1) q.o -= dt * 1.4;
      }
    });
    this.parts = this.parts.filter(function (q) { return q.o > 0; });
  };
  Mech.prototype.draw = function (p) {
    var c = this.ctx, k = this.k; c.setTransform(1, 0, 0, 1, 0, 0); c.clearRect(0, 0, this.cv.width, this.cv.height); c.setTransform(k, 0, 0, k, 0, 0);
    // comida
    this.food.forEach(function (f) {
      if (f.s <= .02) return;
      c.save(); c.translate(f.x, f.y); c.rotate(f.rot); c.scale(f.s, f.s);
      c.shadowColor = 'rgba(90,30,30,.25)'; c.shadowBlur = 6; c.shadowOffsetY = 3;
      c.fillStyle = f.c; rr(c, -f.w / 2, -f.h / 2, f.w, f.h, f.r); c.fill();
      c.shadowColor = 'transparent'; c.fillStyle = 'rgba(255,255,255,.28)'; rr(c, -f.w / 2 + 4, -f.h / 2 + 3, f.w * .5, f.h * .28, f.r / 2); c.fill();
      c.restore();
    });
    // partículas
    this.parts.forEach(function (q) {
      c.globalAlpha = Math.max(0, q.o); c.fillStyle = q.c; c.beginPath(); c.arc(q.x, q.y, q.r, 0, 6.283); c.fill();
      if (q.c === '#f2a33a') { c.globalAlpha = Math.max(0, q.o) * .35; c.beginPath(); c.arc(q.x, q.y, q.r * 2.4, 0, 6.283); c.fill(); }
    });
    c.globalAlpha = 1;
    // enzimas (tijeras moleculares con halo)
    this.enz.forEach(function (e) {
      if (e.o <= 0) return;
      c.globalAlpha = e.o;
      var g = c.createRadialGradient(e.x, e.y, 0, e.x, e.y, 14); g.addColorStop(0, 'rgba(211,32,63,.45)'); g.addColorStop(1, 'rgba(211,32,63,0)');
      c.fillStyle = g; c.beginPath(); c.arc(e.x, e.y, 14, 0, 6.283); c.fill();
      c.fillStyle = '#d3203f'; c.beginPath(); c.arc(e.x, e.y, 5.6, 0, 6.283); c.fill();
      c.strokeStyle = '#d3203f'; c.lineWidth = 1.6; c.beginPath();
      c.moveTo(e.x + Math.cos(e.a) * 4, e.y + Math.sin(e.a) * 4); c.lineTo(e.x + Math.cos(e.a + .5) * 9, e.y + Math.sin(e.a + .5) * 9);
      c.moveTo(e.x + Math.cos(e.a) * 4, e.y + Math.sin(e.a) * 4); c.lineTo(e.x + Math.cos(e.a - .5) * 9, e.y + Math.sin(e.a - .5) * 9); c.stroke();
    });
    c.globalAlpha = 1;
  };
  function rr(c, x, y, w, h, r) { c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); }

  function init(scope) {
    (scope || document).querySelectorAll('[data-dm-mech]:not([data-ready])').forEach(function (r) {
      r.setAttribute('data-ready', '');
      new Mech(r, window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
